import './Pagination.scss';
import { ClayPaginationBarWithBasicItems } from '@clayui/pagination-bar';
import { Provider } from '@clayui/core';
import React, {useEffect, useState} from 'react';

const Pagination = ({ currentPage = 1, pageitems, setCurrentPage, setPageitems, totalItems = 0 }) => {
    const handlePageChange = (page) => {
        setCurrentPage?.(page);
    };

    const [delta, setDelta] = useState(10);

	const deltas = [
		{
			href: '#10',
			label: 10,
		},
		{
			label: 20,
		},
		{
			href: '#30',
			label: 30,
		},
		{
			label: 40,
		},
        {
			href: '#50',
			label: 50,
		}
	];

    useEffect(() => {
        setPageitems?.(delta);
    },[delta, setPageitems]);
    
    return (
        <div className={`p-4 ${totalItems <= 0 ? 'd-none' : ''}`}>
            <ClayPaginationBarWithBasicItems
                active={currentPage}
                activeDelta={delta}
                defaultActive={1}
                deltas={deltas}
                pageitems={pageitems}
                onActiveChange={handlePageChange}
                onDeltaChange={setDelta}
                totalItems={totalItems}
            />
        </div>
    );
};

export default Pagination;
